import { status } from 'skin/event/status'
const click = (obj, form, story, data, d, action) => {
	const key = story.s.mProd.table.pReview.row
	if (obj.key === key) return status.ignore
	return status.action
}

export default click
